export const ActiveRed = () => {
    return (
        <svg aria-hidden width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1582_1365)">
                <rect x="0.505859" width="32" height="32" rx="16" fill="#FFDAD5" />
                <path
                    d="M9.53086 13C9.53086 11.8938 10.4246 11 11.5309 11C12.6309 11 13.5309 11.8938 13.5309 13C13.5309 14.1062 12.6309 15 11.5309 15C10.4246 15 9.53086 14.1062 9.53086 13ZM23.5309 13C23.5309 14.1062 22.6309 15 21.5309 15C20.4246 15 19.5309 14.1062 19.5309 13C19.5309 11.8938 20.4246 11 21.5309 11C22.6309 11 23.5309 11.8938 23.5309 13ZM21.0059 20.5C21.8371 20.5 22.5059 21.1688 22.5059 22C22.5059 22.8312 21.8371 23.5 21.0059 23.5H12.0059C11.1746 23.5 10.5059 22.8312 10.5059 22C10.5059 21.1688 11.1746 20.5 12.0059 20.5H21.0059ZM32.5059 16C32.5059 24.8375 25.3434 32 16.5059 32C7.66836 32 0.505859 24.8375 0.505859 16C0.505859 7.1625 7.66836 0 16.5059 0C25.3434 0 32.5059 7.1625 32.5059 16ZM16.5059 29C23.6871 29 29.5059 23.1812 29.5059 16C29.5059 8.81875 23.6871 3 16.5059 3C9.32461 3 3.50586 8.81875 3.50586 16C3.50586 23.1812 9.32461 29 16.5059 29Z"
                    fill="#930005"
                />
            </g>
            <defs>
                <clipPath id="clip0_1582_1365">
                    <rect x="0.505859" width="32" height="32" rx="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
